import o, { useState as B } from "react";
import { c as t, t as _ } from "./app-a75c1d35.mjs";
import { I as S, W as F } from "./Icon-3122c134.mjs";
import { L as G } from "./Link-479ac100.mjs";
import { B as b } from "./Block-9b78bd10.mjs";
import { B as v } from "./Button-c598cb52.mjs";
import "./LinkContext-0c83848a.mjs";
import "./useClickOutside-726e7c36.mjs";
const J = "job-card", H = "job-card--image-skeleton-loading", P = "skeleton", W = "job-card--text-skeleton-loading", O = "job-card--pressed", $ = "job-card__title", A = "job-card__title--loading", M = "skeleton-loading", z = "job-card__employerName", U = "job-card__expiry-label", q = "job-card__go-to-job-container", K = "job-card__go-to-job-container__title", Q = "job-card__location", V = "job-card__location-icon", X = "job-card__go-to-job-icon", Y = "job-card__logo", Z = "job-card__logo--place-holder", D = "job-card__logo__image", oo = "job-card__logo__image--hide", eo = "job-card--header", to = "job-card--score", ao = "job-card--score--number", ro = "job-card--title-company", no = "job-card--title-company--full", so = "job-card--footer", lo = "job-card--footer--left-item", co = "desktop", bo = "job-card--footer--right-item", e = {
  jobCard: J,
  jobCardImageSkeletonLoading: H,
  skeleton: P,
  jobCardTextSkeletonLoading: W,
  jobCardPressed: O,
  jobCardTitle: $,
  jobCardTitleLoading: A,
  skeletonLoading: M,
  jobCardEmployerName: z,
  jobCardExpiryLabel: U,
  jobCardGoToJobContainer: q,
  jobCardGoToJobContainerTitle: K,
  jobCardLocation: Q,
  jobCardLocationIcon: V,
  jobCardGoToJobIcon: X,
  jobCardLogo: Y,
  jobCardLogoPlaceHolder: Z,
  jobCardLogoImage: D,
  jobCardLogoImageHide: oo,
  jobCardHeader: eo,
  jobCardScore: to,
  jobCardScoreNumber: ao,
  jobCardTitleCompany: ro,
  jobCardTitleCompanyFull: no,
  jobCardFooter: so,
  jobCardFooterLeftItem: lo,
  desktop: co,
  jobCardFooterRightItem: bo
};
function io({
  title: r,
  employerName: d,
  location: n,
  link: l,
  image: s,
  isDataLoading: a = !0,
  score: i,
  scoreLabel: h = "match",
  variant: g = "default"
}) {
  const L = g === "without-logo", E = !L, [f, j] = B(!1), y = l ? G : "div", p = l ? { href: l, disableLinkTextStyle: !0, target: "_blank" } : {};
  return /* @__PURE__ */ o.createElement(
    y,
    {
      className: e.jobCard,
      "data-testid": "job-card",
      "data-variant": g,
      href: p.href || "",
      ...p
    },
    /* @__PURE__ */ o.createElement("div", { className: t(e.jobCardHeader) }, /* @__PURE__ */ o.createElement(
      "div",
      {
        className: t(
          e.jobCardTitleCompany,
          L && e.jobCardTitleCompanyFull
        )
      },
      /* @__PURE__ */ o.createElement(
        "p",
        {
          className: t(
            e.jobCardTitle,
            _.textsBodyTextBold,
            a && e.jobCardTextSkeletonLoading
          )
        },
        r
      ),
      /* @__PURE__ */ o.createElement(
        "p",
        {
          className: t(
            e.jobCardEmployerName,
            _.textsBodyText,
            a && e.jobCardTextSkeletonLoading
          ),
          style: { "--text-width": a ? 0.7 : 1 }
        },
        d
      )
    ), E && /* @__PURE__ */ o.createElement(
      "div",
      {
        className: t(
          e.jobCardLogo,
          a && e.jobCardImageSkeletonLoading,
          !a && (!f || !s) && e.jobCardLogoPlaceHolder
        )
      },
      s && /* @__PURE__ */ o.createElement(
        "img",
        {
          className: t(
            e.jobCardLogo,
            a && e.jobCardLogoImageHide
          ),
          src: s,
          alt: "",
          "aria-hidden": "true",
          loading: "lazy",
          onLoad: () => j(!0),
          onError: (m) => {
            m.currentTarget.classList.add(e.jobCardLogoImageHide), j(!1);
          }
        }
      )
    )),
    i && /* @__PURE__ */ o.createElement("div", { className: t(e.jobCardScore) }, /* @__PURE__ */ o.createElement("span", null, /* @__PURE__ */ o.createElement(
      "span",
      {
        className: t(e.jobCardScoreNumber)
      },
      `${i}%`
    ), /* @__PURE__ */ o.createElement("span", null, h))),
    /* @__PURE__ */ o.createElement("div", { className: t(e.jobCardFooter) }, /* @__PURE__ */ o.createElement(
      "div",
      {
        className: t(
          e.jobCardFooterLeftItem,
          a && e.jobCardTextSkeletonLoading
        ),
        style: {
          "--extra-width": a ? "0%" : "10%"
        }
      },
      !a && /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(S, { icon: F.LOCATION, width: 20, height: 21 }), /* @__PURE__ */ o.createElement(
        "p",
        {
          className: t(
            e.jobCardLocation,
            _.textsBodyText
          )
        },
        n === "unknown" || !n ? "Finland" : n
      ))
    ), /* @__PURE__ */ o.createElement(
      "div",
      {
        className: t(
          e.jobCardFooterRightItem,
          a && e.jobCardTextSkeletonLoading
        )
      },
      !a && /* @__PURE__ */ o.createElement("span", { className: t(e.jobCardGoToJobContainer) }, /* @__PURE__ */ o.createElement(
        "span",
        {
          className: t(
            e.jobCardGoToJobContainerTitle,
            _.buttonTitle
          )
        },
        "Go to job site"
      ), /* @__PURE__ */ o.createElement(
        S,
        {
          className: t(e.jobCardGoToJobIcon),
          icon: F.ARROW_UP_RIGHT,
          color: "#002EA2"
        }
      ))
    ))
  );
}
const jo = "job-list--white", mo = "job-list--light-blue", Co = "job-list--gray", go = "job-list__range", Lo = "job-list__range-bottom", po = "job-list__footer", uo = "mobile", _o = "job-list__show-more", c = {
  jobListWhite: jo,
  jobListLightBlue: mo,
  jobListGray: Co,
  jobListRange: go,
  jobListRangeBottom: Lo,
  jobListFooter: po,
  mobile: uo,
  jobListShowMore: _o
};
function ho(r, d, n, l) {
  const s = (r - 1) * d + 1;
  return l <= 0 || n <= 0 || s > l ? { from: 0, to: 0 } : {
    from: s,
    to: Math.min(s + n - 1, l)
  };
}
function Eo(r, d, n) {
  return `Showing Jobs ${r} – ${d} of ${n}`;
}
function fo(r) {
  return Array(r).fill({ isDataLoading: !0 });
}
function Ro({
  jobCards: r,
  skeletonLoadingCount: d = 12,
  topPadding: n = b.Padding.NONE,
  bottomPadding: l = b.Padding.NONE,
  visibleCount: s,
  rangeText: a,
  totalJobs: i,
  page: h = 1,
  pageSize: g = 12,
  formatRange: L = Eo,
  showRange: E = !0,
  showMoreText: f,
  showMoreVisible: j,
  onShowMore: y,
  showLogo: p = !0,
  backgroundColor: m
}) {
  const R = p ? "default" : "without-logo", T = r ?? fo(d), N = typeof s == "number" ? T.slice(0, s) : T, I = N.filter((u) => !u.isDataLoading).length, x = i ?? r?.length ?? I, k = ho(h, g, I, x), C = E && (a ?? (typeof i == "number" ? L(k.from, k.to, x) : void 0));
  return /* @__PURE__ */ o.createElement(
    b,
    {
      "data-testid": "job-list",
      topPadding: n,
      bottomPadding: l,
      className: t(
        m === "white" && c.jobListWhite,
        m === "lightBlue" && c.jobListLightBlue,
        m === "gray" && c.jobListGray
      )
    },
    C && /* @__PURE__ */ o.createElement(b.Content, null, /* @__PURE__ */ o.createElement("p", { className: c.jobListRange, "data-testid": "job-list-range" }, C)),
    /* @__PURE__ */ o.createElement(b.Content, null, N.map((u, w) => /* @__PURE__ */ o.createElement(
      io,
      {
        key: w,
        ...u,
        variant: u.variant ?? R
      }
    ))),
    (C || j) && /* @__PURE__ */ o.createElement(b.Content, null, /* @__PURE__ */ o.createElement("div", { className: c.jobListFooter }, C && /* @__PURE__ */ o.createElement("p", { className: c.jobListRangeBottom }, C), j && /* @__PURE__ */ o.createElement("div", { className: c.jobListShowMore }, /* @__PURE__ */ o.createElement(
      v.Primary,
      {
        text: f || "Show more jobs",
        onClick: y,
        "data-testid": "job-list-show-more"
      }
    ))))
  );
}
export {
  io as JobCard,
  Ro as JobList,
  Eo as formatJobsRange,
  ho as getDisplayedJobsRange
};
//# sourceMappingURL=JobList.js.map
